import styled from "@emotion/styled";
import React from "react";
import { Grid, Paper, Stack } from "@mui/material";
import { Button, Typography } from "@platform/design-system";
import {
  CheckBoxOutlined,
  SaveOutlined,
  UploadFileOutlined,
  Launch,
} from "@mui/icons-material";

import { DocumentsHelperBackgroundSvg } from "../../../../assets";
import { ROUTE_NAMES } from "../../../../constants";
import { sortProductsByCoverage } from "../../../../pages/RFP/utils";

const DocumentsHelperImageContainer = styled(Grid)(() => ({
  position: "relative",
  width: "100%",
  height: "304px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  flex: 1,
}));

const DocumentsHelperImage = styled("img")(() => ({
  position: "absolute",
  top: 0,
  left: "-27px",
  width: "108%",
  height: "100%",
  objectFit: "cover",
}));
const DocumentsHelperTextContainerWithImg = styled(Grid)(({ theme }) => ({
  color: theme.palette.common.white,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
  alignItems: "flex-start",
  padding: "2rem",
  position: "relative",
  zIndex: 1,
  height: "100%",
}));
const DocumentsHelperTextContainer = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "2rem 3.75rem 2rem 2.4rem",
}));

const DocumentsHelper = ({ documentTypes }) => {
  const handleChecklist = () => {
    if (documentTypes.length) {
      const checkListData = documentTypes.map((doc) => {
        const { documentTypeName } = doc;
        let {
          coverages: { optional, required },
        } = doc;
        optional = sortProductsByCoverage(optional, "coverageName");
        required = sortProductsByCoverage(required, "coverageName");

        return {
          documentTypeName,
          coverages: {
            optional: optional.map((item) => item.coverageName),
            required: required.map((item) => item.coverageName),
          },
        };
      });
      // eslint-disable-next-line no-undef
      const checkListDataBase64 = btoa(JSON.stringify(checkListData));

      const link = document.createElement("a");
      link.href = `/${ROUTE_NAMES.DOCUMENT_CHECKLIST}?data=${checkListDataBase64}`;
      link.target = "_blank";

      link.click();
    }
  };

  return (
    <Grid container component={Paper} mb={5}>
      <DocumentsHelperImageContainer size={3.5}>
        <DocumentsHelperImage
          src={DocumentsHelperBackgroundSvg}
          alt="Documents Helper Background"
        />
        <DocumentsHelperTextContainerWithImg>
          <Typography variant="header-large" color="inherit">
            How to upload required documents
          </Typography>
          <Stack
            gap={2}
            direction="horizontal"
            style={{ opacity: "0.7", flexDirection: "row" }}
          >
            <UploadFileOutlined style={{ color: "white" }} />
            <CheckBoxOutlined style={{ color: "white" }} />
            <SaveOutlined style={{ color: "white" }} />
          </Stack>
        </DocumentsHelperTextContainerWithImg>
      </DocumentsHelperImageContainer>
      <DocumentsHelperTextContainer size={8.5} gap={2}>
        <Typography variant="body-medium" component="p">
          Required documents are based on coverage type, group size, and carrier
          requirements to quote. You can save your work and come back at any
          time.
        </Typography>
        <Grid container alignItems="center">
          <Grid size={1}>
            <Typography variant="display-small">1</Typography>
          </Grid>
          <Grid size={11}>
            <Typography variant="body-medium" component="p">
              Use Your RFP Document Checklist to get your documents ready.
            </Typography>
          </Grid>
        </Grid>
        <Grid container alignItems="center">
          <Grid size={1}>
            <Typography variant="display-small">2</Typography>
          </Grid>
          <Grid size={11}>
            <Typography variant="body-medium" component="p">
              Upload one or many documents by Document Type.
            </Typography>
          </Grid>
        </Grid>
        <Grid container alignItems="center">
          <Grid size={1}>
            <Typography variant="display-small">3</Typography>
          </Grid>
          <Grid size={11}>
            <Typography variant="body-medium" component="p">
              Indicate which coverage(s) each document pertains to.
            </Typography>
          </Grid>
        </Grid>
        <Button
          size="sm"
          variant="secondary"
          sx={{ width: "fit-content" }}
          onClick={handleChecklist}
          startIcon={<Launch />}
        >
          YOUR RFP DOCUMENT CHECKLIST
        </Button>
      </DocumentsHelperTextContainer>
    </Grid>
  );
};

export default DocumentsHelper;
